module.exports = __webpack_public_path__ + "assets/icons/youtube-blue-light.svg";